import { Observable } from "rxjs/Observable";
import { Injectable } from "@angular/core";
import "rxjs/add/operator/map";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Corps } from "app/models/corps";
@Injectable()
export class CorpsService {
  private url = `/api/informations/corps`;

  constructor(private http: HttpClient) {}

  public find(): Observable<[Corps]> {
    const params = new HttpParams()
      .set("size", "page")
      .set("size", "50")
      .set("sortName", "libelle")
      .set("sortType", "ASC");
    return this.http.get<[Corps]>(this.url, { params: params });
  }

  /**
   * create a  new Corps
   * @param corps
   */
  create(corps: Corps) {
    return this.http.post(this.url, corps).map(data => {
      console.log(data);
    });
  }
  /**
   * delete a new Corps
   * @param corps
   */
  delete(corps: Corps) {
    return this.http.delete(`${this.url}/${corps.id}`).map(data => {
      console.log(data);
    });
  }
  /**
   * update a corps
   * @param corps
   */
  update(corps: Corps) {
    return this.http.put(`${this.url}/${corps.id}`, corps).map(data => {
      console.log(data);
    });
  }
}



// WEBPACK FOOTER //
// /home/masdev/Documents/NEPHROSYSTEMLAST/nephrosystem-webapp/src/app/core/corps.service.ts